import { api } from '../index';

export const getCollections = () => api.get('/credit-policy');

export const getUserDataByMasterFile = id => api.get(`/credit-policy/${id}`);
